

export const GovernedCounter = ({
    queuedCount,
    pendingCount,
    historyCount
}) => {
    return (
        <div className="grid grid-cols-3 gap-2 sm:min-w-[360px]">
            <div className="rounded-md border border-border bg-white px-1 py-1 sm:py-2 sm:px-3">
                <p className="text-[10px] uppercase tracking-[0.14em] text-gray-600">
                    Queued
                </p>
                <p className="mt-1 text-base font-semibold text-primary">
                    {queuedCount}
                </p>
            </div>
            <div className="rounded-md border border-border bg-white px-1 py-1 sm:py-2 sm:px-3">
                <p className="text-[10px] uppercase tracking-[0.14em] text-gray-600">
                    Pending
                </p>
                <p className="mt-1 text-base font-semibold text-primary">
                    {pendingCount}
                </p>
            </div>
            <div className="rounded-md border border-border bg-white px-1 py-1 sm:py-2 sm:px-3">
                <p className="text-[10px] uppercase tracking-[0.14em] text-gray-600">
                    History
                </p>
                <p className="mt-1 text-base font-semibold text-primary">
                    {historyCount}
                </p>
            </div>
        </div>
    )
}